import React from 'react';
import { Badge, BadgePriority, Tooltip } from 'wix-ui-tpa/cssVars';
import { useExperiments } from '@wix/yoshi-flow-editor';
import type { Label as LabelType } from 'root/apiTypes';
import { dataHooks } from 'root/dataHooks';
import { st, classes } from './Label.st.css';
import { ReactSVG } from 'react-svg';
import { useLabelLogic } from 'root/components/Menus/Label/Label.logic';

export const Label = ({ label }: { label: LabelType }) => {
  const { hideTooltip, useLabelIconColor } = useLabelLogic();
  const { experiments } = useExperiments();
  const renderIconAsImage = experiments.enabled('specs.restaurants.svgIconRenderAsImage');
  const iconUrl = label.icon?.url ?? '';
  const iconClassName = st(classes.icon, useLabelIconColor ? classes.useLabelIconColor : '');

  return (
    <div role="listitem">
      <Tooltip
        appendTo="window"
        className={classes.labelTooltip}
        content={label.name}
        contentClassName={classes.labelTooltipContent}
        disabled={hideTooltip}
        moveBy={{ x: 0, y: 4 }}
      >
        <div tabIndex={hideTooltip ? -1 : 0}>
          <Badge
            className={classes.label}
            data-hook={dataHooks.item.label}
            priority={BadgePriority.light}
            icon={
              renderIconAsImage ? (
                <img
                  alt={label.name}
                  aria-label={label.name}
                  className={iconClassName}
                  src={iconUrl}
                  title={label.name}
                />
              ) : (
                <ReactSVG
                  aria-label={label.name}
                  className={st(classes.icon, useLabelIconColor ? classes.useLabelIconColor : '')}
                  role="img"
                  src={label.icon?.url ?? ''}
                  title={label.name}
                />
              )
            }
          >
            <div className={classes.labelName}>{label.name}</div>
          </Badge>
        </div>
      </Tooltip>
    </div>
  );
};
